"use client";

import { Box, Container, createTheme, MantineThemeProvider } from "@mantine/core";
import clsx from "clsx";

import AudiencePill from "@/app/(marketing)/components/AudiencePill";
import BreadcrumbJsonLd from "@/app/(marketing)/components/BreadcrumbJsonLd";
import Footer from "@/app/(marketing)/components/Footer";
import Header from "@/app/(marketing)/components/Header";

import { caveat, jetbrainsMono } from "./fonts";
import classes from "./layout.module.css";

/* Marketing containers swap Mantine's fixed 16px gutter for a fluid one so
   content doesn't hug the viewport at tablet/laptop widths (Container
   size="lg" caps at ~1140px, so below ~1200px the gutter is all you see).
   The nested theme scopes this to marketing only; header, pages, and footer
   all inherit it so their edges stay aligned. */
const marketingTheme = createTheme({
  components: {
    Container: Container.extend({
      defaultProps: {
        px: "clamp(var(--mantine-spacing-md), 4vw, var(--mantine-spacing-2xl))",
      },
    }),
  },
});

export default function MarketingLayout({ children }: { children: React.ReactNode }) {
  // The font variables sit on the root so the header, the page and the footer
  // all reach them. A portaled dropdown renders outside it and must not portal
  // if it needs either face. The root is also the sticky header's containing
  // block, so it must never clip or scroll.
  return (
    <MantineThemeProvider theme={marketingTheme}>
      <BreadcrumbJsonLd />
      <Box className={clsx(classes.root, caveat.variable, jetbrainsMono.variable)}>
        <Header />
        <Box component="main" className={classes.main}>
          {children}
        </Box>
        <Footer />
        <AudiencePill />
      </Box>
    </MantineThemeProvider>
  );
}
